import React, { Component } from "react";
import { Grid, Image, Pagination } from "semantic-ui-react";
import ModalMultimediaImage from "../../layout/ModalMultimediaImage";
import { firebase } from "../../../firebase";
import "./styles/styles.css";

class GalleryImageItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DataImages: [],
      page: 1,
      itemsPerPage: 12
    };
  }

  componentDidMount() {
    const docRef = firebase
      .firestore()
      .collection("gallery-images")
      .orderBy("date", "desc");
    docRef
      .get()
      .then(querySnapshot => {
        const images = [];
        querySnapshot.forEach(doc => {
          const { url } = doc.data();
          images.push({
            key: doc.id,
            url
          });
        });
        this.setState({ DataImages: images });
      })
      .catch(function(error) {});
  }

  setPageNum = (event, { activePage }) => {
    this.setState({ page: activePage });
  };

  render() {
    const { page, itemsPerPage } = this.state;
    const totalPages = this.state.DataImages.length / itemsPerPage;
    const Images = this.state.DataImages.slice(
      (page - 1) * itemsPerPage,
      (page - 1) * itemsPerPage + itemsPerPage
    );

    return (
      <>
        <Grid style={{ display: "flex", justifyContent: "center" }}>
          <Grid.Row centered>
            {Images.map((tile, key) => (
              <Grid.Column
                className="col-12 col-lg-3 col-md-4 col-sm-6 p-2"
                key={key}
              >
                <ModalMultimediaImage
                  render={<Image src={tile.url} className="imageGallery" />}
                  renderImage={<Image src={tile.url} className="img-modal" />}
                />
              </Grid.Column>
            ))}
          </Grid.Row>
          <Grid.Row centered>
            <Pagination
              activePage={page}
              totalPages={totalPages}
              siblingRange={1}
              onPageChange={this.setPageNum}
            />
          </Grid.Row>
        </Grid>
      </>
    );
  }
}

export default GalleryImageItem;
